import { useCmsHashState } from '../../hooks/useHashState';

/**
 * Open/close state for the Google Reviews drawer, persisted in the URL hash
 * (SSR-safe, shareable, survives navigation). Mirrors `useOpenRewardModal`.
 *
 * A single drawer is rendered at the page-content level and is open for
 * whichever product id is in the hash. Any rating trigger on the page
 * (comparison-table column, product card, …) opens it by product id.
 */
const useOpenGoogleReviewModal = () => {
  const [queryParams, setQueryParams] = useCmsHashState<GoogleReviewModalState>({
    googleReviewProductId: 'string',
  });

  const googleReviewProductId = queryParams.googleReviewProductId ?? '';

  const openModal = (googleReviewProductId: string) => {
    setQueryParams({ googleReviewProductId });
    return true;
  };

  const closeModal = () => {
    setQueryParams({ googleReviewProductId: undefined });
    return false;
  };

  return {
    openModal,
    closeModal,
    googleReviewProductId,
  };
};

export type GoogleReviewModalState = {
  googleReviewProductId: string;
};

export default useOpenGoogleReviewModal;
